/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Observable } from 'rxjs';
import { JsonApiResource } from '@irian-ro/abstract-resource';
import { Inject, Injectable, Optional } from '@angular/core';
import { AddressDTO } from '@well/address-management-domain-model';
import {
  LocalAddressSearchServiceInterface,
  LocalAddressSearchServiceTaken,
} from '@well/address-management/data-access';

@Injectable()
export class LocalAddressSearchService {
  private customerUuid: string | undefined ;

  constructor(
    @Inject(LocalAddressSearchServiceTaken)
    @Optional()
    private delAddressTemplateResourceService: LocalAddressSearchServiceInterface
  ) {}

  getSearchResults(searchValue: string): Observable<JsonApiResource<AddressDTO[], any>> {
    const event = {
      filters: {
        searchQuery: {
          value: searchValue,
          matchMode: 'contains',
        },
      },
    };

    if (this.delAddressTemplateResourceService) {
      return this.delAddressTemplateResourceService.getSearchResults(event, undefined, this.customerUuid);
    } else {
      throw new Error('no LocalAddressSearchServiceInterface provided');
    }
  }

  setCustomerUuid(customerUuid: string) {
    this.customerUuid = customerUuid;
  }
}
